import React from "react";
import Carousel from "./Carousel";
import "./subscribers-meet-slider.m.css";

const OPTIONS = {};
const SLIDE_COUNT = 9;
const SLIDES = Array.from(Array(SLIDE_COUNT).keys());

const SubscribersMeetSlider = () => (
  <div className="full-width-with-padding" styleName="sandbox">
    <section styleName="sandbox__carousel">
      <Carousel slides={SLIDES} options={OPTIONS} />
    </section>
  </div>
);

export { SubscribersMeetSlider };
